import { ContextGlobal } from './ContextGlobal'

export const Context = {
  Global: ContextGlobal,
}
